// extracted by css-extract-rspack-plugin
export default {"root":"root-gg0KtF","column":"column-v7EgxV"};